import { getMockBearerToken } from '@/utils/auth/mockAuthSession';

/**
 * Monorepo .NET API (Kestrel) — same host as workspace routes, tickets, settings, etc.
 * Set `REACT_APP_POOLED_TENANT_API_URL` to the API base (e.g. http://localhost:8080 with `make up` + `make run-api`).
 */
export function getBackendBaseUrl(): string {
  const u = (process.env.REACT_APP_POOLED_TENANT_API_URL || '').trim().replace(/\/$/, '');
  if (!u) {
    throw new Error(
      'REACT_APP_POOLED_TENANT_API_URL is not set. Point it at the .NET API (e.g. http://localhost:8080).',
    );
  }
  return u;
}

/** Bearer from mock/Cognito-shaped session, then REACT_APP_DEV_JWT. */
export function resolveBearerToken(sessionJwt?: string | null): string {
  const fromSession = (sessionJwt || '').trim();
  if (fromSession) return fromSession;
  return (getMockBearerToken() || '').trim();
}

export function backendRequestHeaders(sessionJwt?: string | null): Record<string, string> {
  const h: Record<string, string> = { 'Content-Type': 'application/json' };
  const bearer = resolveBearerToken(sessionJwt);
  if (bearer) {
    h.Authorization = `Bearer ${bearer}`;
  }
  const key = process.env.REACT_APP_POOLED_TENANT_API_KEY;
  if (key) {
    h['x-api-key'] = key;
  }
  return h;
}
